module.exports = {
	"base": {
		"welcome": "Bem-vindo ao Mulligans, %{name}!",
		"user": "Informações do Utilizador",
		"devices": "Dispositivos",
		"refunds": "Reembolsos",
		"resources": "Recursos",
		"transactions": "Encomendas e Devoluções",
		"email": "Correio electrónico",
		"password": "Palavra-passe",
		"save": "Salvar",
		"sign-out": "Terminar sessão",
		"cancel": "Cancelar",
		"close": "Fechar",
		"learn-more": "Saber mais",
		"required": "Necessário",
		"support": "Suporte",
		"bookshelf": "Bookshelf",
		"launch": "Iniciar",
		"download": "Transferir",
		"details": "Detalhes",
		"cannot-be-blank": "%{field} não pode ficar em branco.",
		"saving": "A guardar…",
		"done": "Concluído",
		"failed": "Falha",
		"copy": "Copiar"
	},
	"signin": {
		"login-failure": "E-mail ou palavra-passe incorretos",
		"welcome-large": "Bem-vindo ao <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Entrar",
		"forgot-password": "Esqueceu-se da palavra-passe?",
		"new-to-vst": "Novo em %{brand}?",
		"create-account": "Criar uma conta",
		"signing-in": "A iniciar sessão...",
		"signin-failed": "Falha ao iniciar sessão"
	},
	"transactions": {
		"price": "Preço",
		"excluded": "(Excluindo IVA)",
		"quantity": "Quantidade",
		"confirmation#": "Confirmação n.º",
		"payment": "Pagamento",
		"purchased": "Comprado",
		"purchase-details": "Detalhes da compra",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Imposto",
		"loading": "Olá, maravilhoso gastador, estamos a carregar as suas transações...",
		"no-purchases": "Não tem compras.",
		"seller-vat": "IVA do vendedor",
		"total-vat": "Total %{vat} Pago",
		"portion": "%{subTax} IVA %{rate}%",
		"vat-disclosure": "O preço inclui %{vat}",
		"purchases": "Compras",
		"refunded-items": "Itens com reembolso",
		"book-title": "Título do livro",
		"refund-details": "Detalhes do reembolso",
		"print-receipt": "Imprimir recibo",
		"request-refund": "Pedir reembolso",
		"expired": "Expirado",
		"expires-in": "Expira a %{date}",
		"details-refund": "Detalhes e reembolso",
		"modal": {
			"cant-refund-title": "Reembolso não disponível",
			"cant-refund": "O seu livro não pode ser reembolsado devido a um ou mais dos motivos seguintes.",
			"cant-refund-1": "Já foi visualizada uma grande parte do seu livro.",
			"cant-refund-2": "Já decorreram mais de 14 dias após a data de compra.",
			"cant-refund-3": "O seu código de recursos online foi apresentado.",
			"cant-refund-4": "O seu livro já foi reembolsado anteriormente.",
			"cant-refund-5": "Todos os códigos já foram obtidos e/ou reembolsados.",
			"cant-refund-6": "Já decorreram mais de 30 dias após a data de compra.",
			"cant-refund-support": "Se ainda tem dúvidas sobre a política de reembolsos de %{brand}, contacte o <a href='%{support_url}' target='_blank'>Suporte</a>."
		},
		"license": {
			"perpetual": "O acesso online não expira",
			"days": "%{days} dia(s) de acesso"
		}
	},
	"devices": {
		"description": "A %{brand} permite-lhe ter <span>%{desktop}</span> computadores e <span>%{mobile}</span> dispositivos móveis/tablets ativos em simultâneo.",
		"loading": "Olá, estamos a obter os seus dispositivos :)",
		"no-active": "Não tem dispositivos ativos.",
		"deactivate": "Desativar"
	},
	"user": {
		"personal-information": "Informações Pessoais",
		"security-information": "Informações de segurança",
		"notifications": "Notificações",
		"first-name": "Nome",
		"last-name": "Sobrenome",
		"change-password-title": "Alterar Palavra-passe",
		"current-password": "Palavra-passe atual",
		"new-password": "Nova Palavra-passe",
		"security-password": "Senha",
		"confirm-new-password": "Confirmar Nova Palavra-passe",
		"security-question": "Pergunta de segurança",
		"security-info-change": "Alterar",
		"question": "Pergunta",
		"answer": "Resposta",
		"notifications-text": "Quero receber notificação por e-mail sobre atualizações ocasionais relativas à atividade da minha conta, atualizações de produtos e ofertas especiais.",
		"loading": "O Spot está a obter as suas informações de utilizador, aguarde um momento 🐶",
		"change-password-text": "A palavra-passe tem de conter no mínimo 8 carateres, uma letra maiúscula, uma letra minúscula e um caráter especial. ",
		"email-locked": "Correio electrónico bloqueado",
		"email-locked-description": "Não tem permissão para alterar o seu e-mail. ",
		"email-locked-more": "Contacte o seu administrador.",
		"security-question6": "Qual é o seu desporto favorito?",
		"security-question7": "Qual é o seu sabor de gelado favorito?",
		"security-question8": "Qual é o seu nome de animal de estimação favorito?",
		"security-question9": "Quando era jovem, o que queria ser quando fosse grande?",
		"security-question10": "Qual era o apelido do seu professor preferido?",
		"new-password-failure": "A palavra-passe não cumpre os requisitos",
		"confirm-password-failure": "As palavras-passe têm de ser iguais",
		"new-password-tooltip": "Deve conter no mínimo 8 caracteres, uma letra maiúscula, uma letra minúscula e um carácter especial.",
		"enter-valid-email": "Insira um e-mail válido.",
		"password-cannot-be-same": "A palavra-passe não pode ser a mesma que a palavra-passe anterior",
		"incorrect-password": "Palavra-passe incorreta",
		"complete-account": "Parece que precisa de <a href='%{href}'>completar a sua conta</a>.",
		"completing-allows": "Ao completar a sua conta terá a possibilidade de ler livros offline nas nossas aplicações móveis e partilhar notas e destaques com amigos.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Acessórios",
		"access-codes": "Códigos de acesso",
		"print-on-demand": "Imprimir a Pedido",
		"check-pod": "Veja as opções de impressão da editora para os seus livros.",
		"check-now": "Verificar Agora",
		"loading": "Aguarde, estamos a atualizar os seus recursos!",
		"in": "em",
		"access-code-intro": "Um código de acesso é uma palavra-passe utilizada para aceder ao conteúdo dos cursos online. Depois de apresentar um código para um item, não poderá devolvê-lo. Para mais instruções sobre como utilizar os seus códigos de acesso, visite o <a href='%{support_url}' target='_blank'>Suporte</a>.",
		"expires": "Data de expiração:",
		"expiration-message": "Contém instruções sobre como utilizar o seu código de acesso.",
		"copy-fail": "Não foi possível copiar. Selecione o código e copie-o manualmente.",
		"launch-site": "Iniciar site",
		"launch-book": "Iniciar livro",
		"reveal-code": "Mostrar Código",
		"no-resources": "Não tem nenhum recurso.",
		"no-access-codes": "Não tem nenhum código de acesso.",
		"no-ancillaries": "Nenhum acessório para este título",
		"name": "Nome",
		"type": "Tipo",
		"size": "Tamanho",
		"download-all": "Transferir tudo",
		"back": "Voltar para recursos"
	},
	"refunds": {
		"states": {
			"refunded": "Reembolsado",
			"unavailable": "Reembolso indisponível"
		},
		"reasons": {
			"dropped": "Desisti do curso",
			"wrong": "Este livro não é o correto para o meu curso",
			"print": "Optei por comprar a versão em papel",
			"missing": "O livro não contém tudo o que preciso para o meu curso (por ex. um CD, acesso à Web, vídeos)",
			"other": "Outro"
		},
		"bulk": {
			"policy": "Ao clicar no botão &quot;Reembolso total&quot; abaixo, estou a concordar com a política de reembolso da %{brand} <a href='%{policy_url}' target='_blank'></a>.",
			"complete": "Reembolso total",
			"view-details": "Ver detalhes do reembolso",
			"success": "O seu reembolso foi solicitado. Aguarde 48 horas para o processamento.",
			"failure": "Oops - algo correu mal!  Infelizmente, o seu reembolso não foi bem-sucedido.",
			"retry": "Tentar novamente",
			"support": "Contactar o suporte",
			"available-codes": "Códigos disponíveis",
			"codes-selected": "Códigos selecionados",
			"download": "Transferir códigos",
			"partially-refunded": "Parcialmente reembolsado",
			"pick-one": "Tem de selecionar pelo menos um código para proceder ao reembolso"
		},
		"refund": "Reembolso",
		"all": "Reembolsar todos?",
		"missing-reason": "Para continuar, tem de selecionar um motivo",
		"missing-elaboration": "Forneça mais detalhes",
		"policy": "Ao clicar no botão “Complete Refund Request” (Concluir pedido de reembolso), compreendo que se voltar a comprar este livro didático eletrónico %{brand}, não poderei pedir nenhum outro reembolso relativo ao mesmo livro didático eletrónico. Ver a política de reembolso integral.",
		"refunded": "Reembolsado",
		"sorry": "Lamentamos que não tenha ficado satisfeito com a sua compra.",
		"error": "Algo correu mal",
		"error-explain": "Não nos foi possível processar o seu reembolso. Tente novamente.",
		"why": "Pode dizer-nos porquê?",
		"no-refunds": "Não tem itens com reembolso.",
		"select-codes": "Selecionar código(s) a reembolsar:",
		"number": "Quantos?",
		"back": "Voltar para devoluções"
	},
	"purchases": {
		"back": "Voltar para compras"
	},
	"global-bar": {
		"account": "Definições da conta"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/pt.json
 ** module id = 995
 ** module chunks = 0
 **/